import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { formatDuration } from '@src/services/audio';
import { StyledAudioList } from './index.style';
import AudioItem from './AudioItem';

const AudioList = ({
  audios,
  onDelete,
  onPlay,
  playingAudioId,
  isPlaying,
  onAdjust,
}) => {
  const { t } = useTranslation();
  if (!audios.length) return null;

  const totalDuration = audios.reduce((acc, audio) => acc + audio?.duration, 0);
  return (
    <StyledAudioList>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body-16-bold" color={COLOR.darkGray}>
          {t('yourRecordedAudios')}
        </Typography>
        <Typography variant="body-14-regular" color={COLOR.label2[64]}>
          {t('totalDuration', { duration: formatDuration(totalDuration) })}
        </Typography>
      </Box>
      <Box className="audio-list-scroll">
        {audios.map((audio) => (
          <AudioItem
            key={audio.id}
            audio={audio}
            onDelete={onDelete}
            onPlay={onPlay}
            isPlaying={playingAudioId === audio.id && isPlaying}
            onAdjust={onAdjust}
          />
        ))}
      </Box>
    </StyledAudioList>
  );
};

export default AudioList;
